import { Box, Heading, Text } from '@ritualco/jutsu'
import { useContent } from 'lib/content/react'
import { NetworkSection } from './NetworkSection'

type MyNetworkProps = {
  organizationId: string
  workspaceId: string
}

const MyNetwork = ({ workspaceId, organizationId }: MyNetworkProps) => {
  const { formatMessage } = useContent()
  return (
    <>
      <Box mb={17}>
        <Heading as="h3" size="lg" mb={3}>
          {formatMessage({
            id: 'pmportal.restaurantLists.networkSubtitle',
          })}
        </Heading>
        <Text fontSize="small" color="grayscale.secondary">
          {formatMessage({
            id: 'pmportal.restaurantLists.networkDescription',
          })}
        </Text>
      </Box>
      <NetworkSection
        workspaceId={workspaceId}
        organizationId={organizationId}
      />
    </>
  )
}
export default MyNetwork
